import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Check, Pencil, Plus, X } from "lucide-react";
import api, { errMsg } from "@/lib/api";
import { Card } from "@/components/shared";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";

export const DepartmentsTab = () => {
  const [items, setItems] = useState([]);
  const [draft, setDraft] = useState("");
  const [editing, setEditing] = useState(null);
  const load = () => api.get("/departments").then((r) => setItems(r.data));
  useEffect(() => { load(); }, []);
  const add = async () => { if (!draft.trim()) return; try { await api.post("/departments", { name: draft }); setDraft(""); load(); } catch (e) { toast.error(errMsg(e)); } };
  const patch = async (id, body) => { try { await api.patch(`/departments/${id}`, body); setEditing(null); load(); } catch (e) { toast.error(errMsg(e)); } };
  return (
    <Card title="Departments" testid="departments-card" className="max-w-xl">
      <p className="text-xs text-slate-500 mb-3">Used to categorise Internal Team members. Renaming updates everywhere; deactivating keeps existing members' department but hides it from new selections.</p>
      <div className="flex gap-2 mb-3">
        <Input data-testid="dept-new-input" value={draft} onChange={(e) => setDraft(e.target.value)} onKeyDown={(e) => e.key === "Enter" && add()} placeholder="Add a department" className="h-9" />
        <Button data-testid="dept-add-button" onClick={add} disabled={!draft.trim()} className="h-9 bg-teal-600 hover:bg-teal-700"><Plus className="h-4 w-4 mr-1" /> Add</Button>
      </div>
      <div className="divide-y divide-slate-100">
        {items.map((d) => (
          <div key={d.id} className={`flex items-center gap-2 py-2 text-sm ${d.active ? "" : "opacity-60"}`} data-testid={`dept-row-${d.id}`}>
            {editing?.id === d.id ? (<>
              <Input value={editing.name} onChange={(e) => setEditing({ ...editing, name: e.target.value })} className="h-8" data-testid={`dept-edit-input-${d.id}`} autoFocus />
              <button onClick={() => patch(d.id, { name: editing.name })} className="text-emerald-600" data-testid={`dept-save-${d.id}`}><Check className="h-4 w-4" /></button>
              <button onClick={() => setEditing(null)} className="text-slate-400"><X className="h-4 w-4" /></button>
            </>) : (<>
              <span className="flex-1 text-slate-800">{d.name}{!d.active && <span className="ml-2 text-[10px] uppercase text-slate-400">inactive</span>}</span>
              <button onClick={() => setEditing({ id: d.id, name: d.name })} className="text-slate-400 hover:text-slate-800" data-testid={`dept-rename-${d.id}`}><Pencil className="h-3.5 w-3.5" /></button>
              <button onClick={() => patch(d.id, { active: !d.active })} className="text-xs text-teal-700 hover:underline" data-testid={`dept-toggle-${d.id}`}>{d.active ? "Deactivate" : "Activate"}</button>
            </>)}
          </div>
        ))}
      </div>
    </Card>
  );
};
